<template>
  <div v-show="show" :transition="transition">
    <div class="modal" @click.self="clickMask">
      <div class="modal-dialog" :class="modalClass">
        <div class="modal-content">
          <!--Header-->
          <div class="modal-header">
            <slot name="header">
              <a type="button" class="close" @click="cancel">x</a>
              <h4 class="modal-title">
                <slot name="title">
                  {{ title }}
                </slot>
              </h4>
            </slot>
          </div>
          <!--Container-->
          <div class="modal-body">
            <slot></slot>
          </div>
          <!--Footer-->
          <div class="modal-footer">
            <slot name="footer">
              <transition name="fade" mode="out-in">
                <span v-if="loading"><i class="fa fa-fw fa-lg fa-spinner fa-spin"></i></span>
              </transition>
              <button :disabled="loading" type="button" :class="cancelClass" @click="cancel">{{ cancelText }}</button>
              <button :disabled="loading" type="button" :class="okClass" @click="ok">{{ okText }}</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop in"></div>
  </div>
</template>

<script>
  export default {
    name: 'ModalBootstrap',
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      show: {
        type: Boolean,
        twoWay: true,
        default: false
      },
      title: {
        type: String,
        default: 'Modal'
      },
      small: {
        type: Boolean,
        default: false
      },
      large: {
        type: Boolean,
        default: false
      },
      full: {
        type: Boolean,
        default: false
      },
      force: {
        type: Boolean,
        default: false
      },
      transition: {
        type: String,
        default: 'modal'
      },
      okText: {
        type: String,
        default: 'OK'
      },
      cancelText: {
        type: String,
        default: 'Cancelar'
      },
      okClass: {
        type: String,
        default: 'btn btn-info'
      },
      cancelClass: {
        type: String,
        default: 'btn btn-default'
      },
      closeWhenOK: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        duration: null
      }
    },
    computed: {
      modalClass () {
        return {
          'modal-lg': this.large,
          'modal-sm': this.small,
          'modal-full': this.full
        }
      }
    },
    created () {
      if (this.show) {
        document.body.className += ' modal-open'
      }
    },
    beforeDestroy () {
      document.body.className = document.body.className.replace(/\s?modal-open/, '')
    },
    methods: {
      ok () {
        this.$emit('close', {action: 'ok'})
      },
      cancel () {
        this.$emit('close', {action: 'cancel'})
      },
      clickMask () {
        if (!this.force) {
          this.cancel()
        }
      }
    }
  }
</script>

<style scoped>
  .modal {
    display: block;
  }
  .modal-transition {
    transition: all .6s ease;
  }
  .modal-leave {
    border-radius: 1px !important;
  }
  .modal-transition .modal-dialog,
  .modal-transition .modal-backdrop {
    transition: all .5s ease;
  }
  .modal-enter .modal-dialog,
  .modal-leave .modal-dialog {
    opacity: 0;
    transform: translateY(-30%);
  }
  .modal-enter .modal-backdrop,
  .modal-leave .modal-backdrop {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// ModalBootstrap.vue?ceeb0faa